/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlatformType } from './PlatformType';
import {
    PlatformTypeFromJSON,
    PlatformTypeFromJSONTyped,
    PlatformTypeToJSON,
    PlatformTypeToJSONTyped,
} from './PlatformType';

/**
 * 
 * @export
 * @interface ApplicationAddRedirectUriRequest
 */
export interface ApplicationAddRedirectUriRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationAddRedirectUriRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationAddRedirectUriRequest
     */
    redirectUri?: string | null;
    /**
     * 
     * @type {PlatformType}
     * @memberof ApplicationAddRedirectUriRequest
     */
    platformType?: PlatformType;
}



/**
 * Check if a given object implements the ApplicationAddRedirectUriRequest interface.
 */
export function instanceOfApplicationAddRedirectUriRequest(value: object): value is ApplicationAddRedirectUriRequest {
    return true;
}

export function ApplicationAddRedirectUriRequestFromJSON(json: any): ApplicationAddRedirectUriRequest {
    return ApplicationAddRedirectUriRequestFromJSONTyped(json, false);
}

export function ApplicationAddRedirectUriRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationAddRedirectUriRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'redirectUri': json['redirectUri'] === undefined ? undefined : json['redirectUri'] === null ? null : json['redirectUri'],
        'platformType': json['platformType'] == null ? undefined : PlatformTypeFromJSON(json['platformType']),
    };
}

export function ApplicationAddRedirectUriRequestToJSON(json: any): ApplicationAddRedirectUriRequest {
    return ApplicationAddRedirectUriRequestToJSONTyped(json, false);
}

export function ApplicationAddRedirectUriRequestToJSONTyped(value?: ApplicationAddRedirectUriRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'redirectUri': value['redirectUri'],
        'platformType': PlatformTypeToJSON(value['platformType']),
    };
}

